import { variantTypes } from 'shared/constants';


export const getVariantType = (productTypeFromGludo: string): string => {
  switch (productTypeFromGludo) {
    case 'shade':
      return variantTypes.SHADE;

    case 'weight_configure':
      return variantTypes.SIZE;

    default:
      return '';
  }
};
